import { defineMessages } from 'react-intl';

export const dateRangeMessages = defineMessages({
  enterCorrectDateFormat: {
    id: 'dateRange.enterCorrectDateFormat',
    defaultMessage: 'Please enter YYYY',
  },
  enterCorrectDateRange: {
    id: 'dateRange.enterCorrectDateRange',
    defaultMessage:
      "Please enter a 'from' date that is earlier than the 'to' date",
  },
});
